export default __webpack_public_path__ + "static/media/0x4e830f67ec499e69930867f9017aeb5b3f629c73.45361ffe.webp";